module.exports = __webpack_public_path__ + "static/Advantage04@2x.78d9143d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage04@2x.png
// module id = 693
// module chunks = 216210090109534